import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import ReduxNavigator from 'components/Navigator/ReduxNavigator'
import {
  PTO_TEMPLATE,
  PTO_TEMPLATE_COMMIT,
  PTO_TEMPLATE_FRAGMENT,
  APPLY_FAST_FEATURES,
} from 'utils/constants'
import { isObject } from 'utils/types'
import PtoTemplateEditor from 'components/pages/PtoTemplates/Editor'
import PtoTemplateCommit from 'components/pages/PtoTemplates/Commit'
import TemplateFragmentEditor from 'components/pages/PtoTemplates/FragmentEditor'
import AddRemoveVehicleFeaturesContainer from '../../Summary/ChecPlusVehicleSummary/AddRemoveVehicleFeatures/AddRemoveVehicleFeaturesContainer'
import FragmentEditor from '../FragmentEditor'
import FragmentsListEditor from '../FragmentsListEditor'
import TemplateDrawerWrapper from '../TemplateDrawerWrapper/TemplateDrawerWrapper'

const PtoNavigator = ({ selectedId, location }) => (
  <ReduxNavigator
    render={(renderProps) => {
      if (renderProps.id === APPLY_FAST_FEATURES) {
        return (
          <AddRemoveVehicleFeaturesContainer
            {...renderProps}
            location={location}
            showFastFeatureFilters
          />
        )
      }
      if (renderProps.type === PTO_TEMPLATE)
        return <PtoTemplateEditor selectedId={selectedId} />
      if (renderProps.type === PTO_TEMPLATE_FRAGMENT)
        return <TemplateFragmentEditor {...renderProps} />
      if (renderProps.type === PTO_TEMPLATE_COMMIT)
        return <PtoTemplateCommit {...renderProps} />
      if (renderProps.id === 'ptoTemplatesWrapper') {
        return <TemplateDrawerWrapper />
      }
      return (
        renderProps.id &&
        (isObject(renderProps.id) ? (
          <FragmentsListEditor {...renderProps} />
        ) : (
          <FragmentEditor {...renderProps} />
        ))
      )
    }}
    dataTestId="pto-templates-full-page-modal"
  />
)

PtoNavigator.propTypes = {
  selectedId: PropTypes.string,
  location: PropTypes.object.isRequired,
}

export default withRouter(PtoNavigator)
